import { motion } from "framer-motion";
import { Users } from "lucide-react";

import FounderCard from "./FounderCard";
import LeaderCard from "./LeaderCard";
import TeamStats from "./TeamStats";
import TeamPhoto from "./TeamPhoto";


import {
  founders,
  leadership,
  teamInfo,
} from "./team";

const EASE = [0.22, 1, 0.36, 1];

export default function MeetClaimProTeam() {
  return (
    <section
      id="leadership"
      className="relative overflow-hidden bg-[#020617] py-28"
    >
      {/* Background Glow */}

      <div className="pointer-events-none absolute inset-0">

        <div
          className="
            absolute
            left-[-12%]
            top-20
            h-[420px]
            w-[420px]
            rounded-full
            bg-[#21A6E9]/10
            blur-[130px]
          "
        />

        <div
          className="
            absolute
            right-[-12%]
            bottom-10
            h-[420px]
            w-[420px]
            rounded-full
            bg-indigo-500/10
            blur-[130px]
          "
        />

      </div>

      <div className="section-container relative z-10">

        {/* ========================= */}
        {/* HEADER */}
        {/* ========================= */}

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{
            duration: .7,
            ease: EASE,
          }}
          className="text-center"
        >

          <p
            className="
              text-sm
              font-medium
              uppercase
              tracking-[0.35em]
              text-[#21A6E9]
            "
          >
            OUR LEADERSHIP
          </p>

          <h2
            className="
              mt-3
              text-5xl
              font-black
              uppercase
              leading-none
              tracking-tight
              text-white
              lg:text-7xl
            "
          >
            MEET OUR

            <span className="text-[#21A6E9]">
              {" "}CLAIMPRO
            </span>

            {" "}TEAM
          </h2>

          <p
            className="
              mx-auto
              mt-8
              max-w-3xl
              text-xl
              leading-relaxed
              text-slate-300
            "
          >
            A passionate team of innovators and problem solvers
            working 24/7 to keep India's commercial vehicles moving.
          </p>

        </motion.div>

        {/* ========================= */}
        {/* FOUNDERS TITLE */}
        {/* ========================= */}

        <div className="mt-20 flex items-center justify-center gap-6">

          <div className="h-px w-28 bg-[#21A6E9]/60" />

          <h3
            className="
              text-xl
              uppercase
              tracking-wide
              text-white
            "
          >
            OUR

            <span className="text-[#21A6E9]">
              {" "}CO-FOUNDERS & DIRECTORS
            </span>
          </h3>

          <div className="h-px w-28 bg-[#21A6E9]/60" />

        </div>

        {/* ========================= */}
        {/* FOUNDERS */}
        {/* ========================= */}

        <div className={`mt-12 grid gap-[1.5rem] 
        ${founders.length === 1
        ? "mx-auto w-full max-w-[585px]"
        :"lg:grid-cols-2"}
        `}>

          {founders.map((founder) => (
            <FounderCard
              key={founder.id}
              founder={founder}
            />
          ))}
          {/* Connector icon between the two cards */}
  <div
    className="
      absolute
      left-1/2
      top-[44%]
      hidden
      h-12
      w-12
      -translate-x-1/2
      -translate-y-1/2
      items-center
      justify-center
      rounded-full
      border
      border-white/15
      bg-[#020617]
      lg:flex
    "
  >
    <Users size={20} className="text-[#21A6E9]" />
  </div>

        </div>

        {/* ========================= */}
        {/* LEADERSHIP */}
        {/* ========================= */}

        <div
           className={`
              mt-7
              grid
              gap-[0.75rem]
              sm:grid-cols-2
              ${leadership.length < 4 ? "xl:grid-cols-3" : "xl:grid-cols-4"}
            `}
        >
          {leadership.map((member) => (
            <LeaderCard
              key={member.id}
              member={member}
            />
          ))}
        </div>

        {/* ========================= */}
        {/* TEAM PHOTO + STATS */}
        {/* ========================= */}

        <div className="mt-6">
            {/* <TeamStats info={teamInfo} /> */}
            <TeamPhoto info={teamInfo} />
        </div>

      </div>
    </section>
  );
}